/** Strip BOM, whitespace, and optional wrapping quotes from Vite string env vars. */
export function normalizeViteEnvString(raw: string | undefined): string {
  if (raw == null) return "";
  let s = raw.trim().replace(/^\uFEFF/, "");
  if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
    s = s.slice(1, -1).trim();
  }
  return s;
}

const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]", "::1"]);

/**
 * A `supabase start` stack serves plain http on a loopback host, so require https everywhere
 * except there — and only in a dev build, so a production bundle can never accept http.
 */
function isLocalSupabaseStack(u: URL): boolean {
  return import.meta.env.DEV && u.protocol === "http:" && LOOPBACK_HOSTS.has(u.hostname);
}

export function assertValidSupabaseUrl(url: string): void {
  try {
    const u = new URL(url);
    if (u.protocol !== "https:" && !isLocalSupabaseStack(u)) {
      throw new Error(
        `VITE_SUPABASE_URL must use https (got protocol ${u.protocol}). Copy Project URL from Supabase → Settings → API.`
      );
    }
    if (!u.hostname) {
      throw new Error("VITE_SUPABASE_URL is missing a hostname.");
    }
  } catch (e) {
    if (e instanceof TypeError) {
      throw new Error(
        `VITE_SUPABASE_URL is not a valid URL (value starts: ${JSON.stringify(url.slice(0, 40))}). Copy the Project URL from Supabase → Settings → API; no spaces or stray characters.`
      );
    }
    throw e;
  }
}
